import { z } from "zod";
const creditTypes = ["ai_credits", "voice_credits"];
const creditTypeSchema = z.enum(creditTypes);
const USAGE_ALERT_THRESHOLD_PERCENT = 85;
const AiCreditBalanceLevel = {
  Available: "available",
  RunningLow: "running_low",
  Exhausted: "exhausted"
};
function resolveAiCreditBalanceLevel(period) {
  const { balances } = period;
  switch (balances.kind) {
    case "live": {
      if (balances.remaining_credits === 0) {
        return AiCreditBalanceLevel.Exhausted;
      }
      const coveredCredits = period.credits_used - period.credits_overage;
      const capacity = coveredCredits + balances.remaining_credits;
      return coveredCredits / capacity * 100 > USAGE_ALERT_THRESHOLD_PERCENT ? AiCreditBalanceLevel.RunningLow : AiCreditBalanceLevel.Available;
    }
    case "at_period_close":
    case "unknown":
      return period.credits_overage > 0 ? AiCreditBalanceLevel.Exhausted : AiCreditBalanceLevel.Available;
  }
}
export {
  AiCreditBalanceLevel,
  USAGE_ALERT_THRESHOLD_PERCENT,
  creditTypeSchema,
  creditTypes,
  resolveAiCreditBalanceLevel
};
//# sourceMappingURL=creditUsage.js.map
